<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.6129 0.209704L1.70711 0.292893L6 4.585L10.2929 0.292893C10.6834 -0.0976309 11.3166 -0.0976309 11.7071 0.292893C12.0676 0.653377 12.0953 1.22061 11.7903 1.6129L11.7071 1.70711L7.415 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3466 12.0676 10.7794 12.0953 10.3871 11.7903L10.2929 11.7071L6 7.415L1.70711 11.7071C1.31658 12.0976 0.683418 12.0976 0.292893 11.7071C-0.0675905 11.3466 -0.0953204 10.7794 0.209704 10.3871L0.292893 10.2929L4.585 6L0.292893 1.70711C-0.0976309 1.31658 -0.0976309 0.683418 0.292893 0.292893C0.653377 -0.0675905 1.22061 -0.0953204 1.6129 0.209704Z"
      fill="currentColor"
    />
  </svg>
</template>
